import { render, staticRenderFns } from "./ProfilingModal.vue?vue&type=template&id=1c35e2a1&scoped=true"
import script from "./ProfilingModal.vue?vue&type=script&lang=js"
export * from "./ProfilingModal.vue?vue&type=script&lang=js"
import style0 from "./ProfilingModal.vue?vue&type=style&index=0&id=1c35e2a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c35e2a1",
  null
  
)

export default component.exports